/** @format */
import {
    largeButtonSizeStyles,
    mediumButtonSizeStyles,
} from '@mpb-com/feather/components/atoms/button/button.styles';
import { css } from 'styled-components';

import { largeTablet } from '@toucan/client/global/application';

/* eslint-disable @mpb-com/mpb/use-design-tokens, @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
const baseStyles = () => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: var(--layout-spacing-48);
    box-shadow: var(--effects-shadow-base);
    border-radius: 1.6rem;
    background-color: var(--colors-surface-primary);

    .join-now-heading {
        margin-bottom: var(--layout-spacing-16);
    }

    .join-now-content {
        margin-bottom: var(--layout-spacing-24);
    }

    .join-now-button {
        ${largeButtonSizeStyles};
        width: 30rem;
    }

    ${largeTablet(css`
        .join-now-button {
            ${mediumButtonSizeStyles};
            width: 18rem;
        }
    `)}
`;
/* eslint-enable @mpb-com/mpb/use-design-tokens, @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */

export const styles = () => css`
    ${baseStyles()}
`;
